export const serviceComboTranslationsEn = {
  servicesManagement: {
    tabs: {
      combos: 'Combos',
    },
  },
  serviceCombosManagement: {
    addNew: 'Add combo',
    noCombos: 'No combos yet',
    emptyHint: 'Combine at least two services into one visit, with its own duration and price.',
    error: {
      noStoreSelected: 'No store selected.',
      loading: 'Failed to load combos.',
      create: 'Failed to create the combo.',
      update: 'Failed to update the combo.',
      activate: 'Failed to activate the combo.',
      deactivate: 'Failed to deactivate the combo.',
      delete: 'Failed to delete the combo.',
    },
    apiErrors: {
      InvalidServiceComboData: 'Check the name, price, duration, and services. A combo needs at least two services from this store.',
      ServiceComboNotFound: 'This combo no longer exists.',
      PlanUpgradeRequired: 'Service combos are available on the Pro plan.',
      Forbidden: 'You do not have permission to configure service combos.',
      ServiceBelongsToCombo: 'This service still belongs to a combo. Edit or delete that combo first.',
    },
    feedback: {
      created: 'Combo created.',
      updated: 'Combo updated.',
      activated: 'Combo activated.',
      deactivated: 'Combo deactivated.',
      deleted: 'Combo deleted.',
    },
    fields: {
      name: 'Name',
      services: 'Services',
      servicesHelp: 'Choose at least two services. Duration and price start as the total and can be changed.',
      noServices: 'Add services before creating a combo.',
      duration: 'Duration',
      price: 'Price',
      active: 'Active',
    },
    validation: {
      name: 'Enter a name in every language.',
      services: 'Select at least two services.',
      duration: 'Duration must be from 5 to 480 minutes, in steps of 5.',
      price: 'Enter a price of zero or more.',
    },
    dialog: {
      createTitle: 'Add combo',
      editTitle: 'Edit combo',
    },
    card: {
      unnamed: 'Untitled combo',
      removedService: 'Removed service',
      consentFromServices: 'Consent form from included services',
    },
    actions: {
      edit: 'Edit',
      delete: 'Delete',
      activate: 'Activate',
      deactivate: 'Deactivate',
    },
    delete: {
      title: 'Delete combo',
      message: 'Delete {{name}}? Visits already booked keep this combo.',
      confirm: 'Delete',
    },
  },
  customer: {
    appointments: {
      booking: {
        categoryCombos: 'Combos',
      },
    },
  },
};

export const serviceComboTranslationsPt = {
  servicesManagement: {
    tabs: {
      combos: 'Combos',
    },
  },
  serviceCombosManagement: {
    addNew: 'Adicionar combo',
    noCombos: 'Ainda não há combos',
    emptyHint: 'Junte pelo menos dois serviços numa visita, com duração e preço próprios.',
    error: {
      noStoreSelected: 'Nenhuma loja selecionada.',
      loading: 'Não foi possível carregar os combos.',
      create: 'Não foi possível criar o combo.',
      update: 'Não foi possível atualizar o combo.',
      activate: 'Não foi possível ativar o combo.',
      deactivate: 'Não foi possível desativar o combo.',
      delete: 'Não foi possível eliminar o combo.',
    },
    apiErrors: {
      InvalidServiceComboData: 'Verifique o nome, o preço, a duração e os serviços. Um combo precisa de pelo menos dois serviços desta loja.',
      ServiceComboNotFound: 'Este combo já não existe.',
      PlanUpgradeRequired: 'Os combos de serviços estão disponíveis no plano Pro.',
      Forbidden: 'Não tem permissão para configurar combos de serviços.',
      ServiceBelongsToCombo: 'Este serviço ainda pertence a um combo. Edite ou elimine esse combo primeiro.',
    },
    feedback: {
      created: 'Combo criado.',
      updated: 'Combo atualizado.',
      activated: 'Combo ativado.',
      deactivated: 'Combo desativado.',
      deleted: 'Combo eliminado.',
    },
    fields: {
      name: 'Nome',
      services: 'Serviços',
      servicesHelp: 'Escolha pelo menos dois serviços. A duração e o preço começam pela soma e podem ser alterados.',
      noServices: 'Adicione serviços antes de criar um combo.',
      duration: 'Duração',
      price: 'Preço',
      active: 'Ativo',
    },
    validation: {
      name: 'Indique um nome em todos os idiomas.',
      services: 'Selecione pelo menos dois serviços.',
      duration: 'A duração deve ser de 5 a 480 minutos, em intervalos de 5.',
      price: 'Indique um preço igual ou superior a zero.',
    },
    dialog: {
      createTitle: 'Adicionar combo',
      editTitle: 'Editar combo',
    },
    card: {
      unnamed: 'Combo sem nome',
      removedService: 'Serviço removido',
      consentFromServices: 'Consentimento dos serviços incluídos',
    },
    actions: {
      edit: 'Editar',
      delete: 'Eliminar',
      activate: 'Ativar',
      deactivate: 'Desativar',
    },
    delete: {
      title: 'Eliminar combo',
      message: 'Eliminar {{name}}? As marcações já feitas mantêm este combo.',
      confirm: 'Eliminar',
    },
  },
  customer: {
    appointments: {
      booking: {
        categoryCombos: 'Combos',
      },
    },
  },
};

export const serviceComboTranslationsEs = {
  servicesManagement: {
    tabs: {
      combos: 'Combos',
    },
  },
  serviceCombosManagement: {
    addNew: 'Añadir combo',
    noCombos: 'Todavía no hay combos',
    emptyHint: 'Une al menos dos servicios en una visita, con su propia duración y precio.',
    error: {
      noStoreSelected: 'Ninguna tienda seleccionada.',
      loading: 'No se pudieron cargar los combos.',
      create: 'No se pudo crear el combo.',
      update: 'No se pudo actualizar el combo.',
      activate: 'No se pudo activar el combo.',
      deactivate: 'No se pudo desactivar el combo.',
      delete: 'No se pudo eliminar el combo.',
    },
    apiErrors: {
      InvalidServiceComboData: 'Revisa el nombre, el precio, la duración y los servicios. Un combo necesita al menos dos servicios de esta tienda.',
      ServiceComboNotFound: 'Este combo ya no existe.',
      PlanUpgradeRequired: 'Los combos de servicios están disponibles en el plan Pro.',
      Forbidden: 'No tienes permiso para configurar combos de servicios.',
      ServiceBelongsToCombo: 'Este servicio todavía pertenece a un combo. Edita o elimina ese combo primero.',
    },
    feedback: {
      created: 'Combo creado.',
      updated: 'Combo actualizado.',
      activated: 'Combo activado.',
      deactivated: 'Combo desactivado.',
      deleted: 'Combo eliminado.',
    },
    fields: {
      name: 'Nombre',
      services: 'Servicios',
      servicesHelp: 'Elige al menos dos servicios. La duración y el precio empiezan por la suma y se pueden cambiar.',
      noServices: 'Añade servicios antes de crear un combo.',
      duration: 'Duración',
      price: 'Precio',
      active: 'Activo',
    },
    validation: {
      name: 'Escribe un nombre en cada idioma.',
      services: 'Selecciona al menos dos servicios.',
      duration: 'La duración debe ser de 5 a 480 minutos, en intervalos de 5.',
      price: 'Introduce un precio igual o mayor que cero.',
    },
    dialog: {
      createTitle: 'Añadir combo',
      editTitle: 'Editar combo',
    },
    card: {
      unnamed: 'Combo sin nombre',
      removedService: 'Servicio eliminado',
      consentFromServices: 'Consentimiento de los servicios incluidos',
    },
    actions: {
      edit: 'Editar',
      delete: 'Eliminar',
      activate: 'Activar',
      deactivate: 'Desactivar',
    },
    delete: {
      title: 'Eliminar combo',
      message: '¿Eliminar {{name}}? Las citas ya reservadas conservan este combo.',
      confirm: 'Eliminar',
    },
  },
  customer: {
    appointments: {
      booking: {
        categoryCombos: 'Combos',
      },
    },
  },
};
